import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";



//Event Document_List
export const getEventDocumentList = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      apiendpoints.EVENT_DOCUMENT_LIST_API
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// Event_Document_By_Id
export const getEventDocumentById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.EVENT_DOCUMENT_BY_ID_API}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};


//Event_by_id
export const getEventDocumentEventById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.EVENT_DOCUMENT_EVENT_BY_ID}?EventId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

//Event_Document_Update
export const updateEventDocument = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true,true));
    const response = await axioClient.post(
      apiendpoints.EVENT_DOCUMENT_UPDATE_API,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// Event_Document_ADD
export const addEventDocument = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true,true));
    const response = await axioClient.post(
      apiendpoints.EVENT_DOCUMENT_ADD_API,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};


// Event_APPLICATION_Document_ADD
export const EventApplicationAddDocument = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true,true));
    const response = await axioClient.post(
      apiendpoints.EVENT_APPLICATION_DOCUMENT_ADD,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};






// Event_Document_Delete
export const DeleteEventDocument = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.EVENT_DOCUMENT_DELETE_API}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};




export const setDocumentId = (id) => {
  localStorage.setItem("id", id);
};

export const getDocumentId = () => {
  const id = localStorage.getItem("id");
  if (id !== null && id !== undefined) {
    return id;
  } else {
    return null;
  }
};
export const removeDocumentId = () => {
  localStorage.removeItem("id");
};